import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  DuplicateProcurementTypeDocument,
  ProcurementTypeItemFragment,
  ProcurementTypesDataCollectionDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { FormErrors, useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface DuplicateTypeModalForm {
  duplicateName: string
  duplicateDescription: string
  id: number
}

interface Props {
  onClose: () => void
  procurementType: ProcurementTypeItemFragment
}
const DuplicateRequestTypeModal = ({ onClose, procurementType }: Props) => {
  const [duplicateProcurementType] = useMutation(DuplicateProcurementTypeDocument, {
    extractorFn: (data) => data.procurementMutations.duplicateProcurementType,
  })

  const form = useForm<DuplicateTypeModalForm>({
    defaultValues: { id: procurementType.id, duplicateName: '', duplicateDescription: '' },
    validate: () => {
      const errors: FormErrors<DuplicateTypeModalForm> = {}
      return errors
    },
    onSubmit: async (data, { setErrors }) => {
      const result = await duplicateProcurementType({
        variables: {
          id: data.id,
          duplicateName: data.duplicateName,
          duplicateDescription: data.duplicateDescription,
        },
        refetchQueries: [ProcurementTypesDataCollectionDocument],
      })

      const handled = handleResult(result, (errors) => {
        setErrors(errors)
      })
      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })

        handleClose()
      }
      return handled
    },
  })

  const handleSave = async () => {
    form.handleSubmit()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      illustration="input-field"
      title={i18n.t('procurement.purchase_requests.settings.types.modals.duplicate.title')}
      description={i18n.t(
        'procurement.purchase_requests.settings.types.modals.duplicate.description',
        { name: procurementType.name }
      )}
      footer={
        <>
          <Button type="secondary" onClick={handleClose}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.duplicate.buttons.cancel')}
          </Button>
          <Button onClick={handleSave} disabled={form.isSubmitting || !form.dirty}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.duplicate.buttons.save')}
          </Button>
        </>
      }
      onClose={onClose}
    >
      <Box gap="s16">
        <TextField
          label={i18n.t('procurement.purchase_requests.settings.types.modals.detail.labels.name')}
          onChange={(duplicateName) => form.setValues({ ...form.values, duplicateName })}
          value={form.values.duplicateName}
          error={form.errors.duplicateName}
          mandatory
        />
        <TextField
          label={i18n.t(
            'procurement.purchase_requests.settings.types.modals.detail.labels.description'
          )}
          onChange={(duplicateDescription) =>
            form.setValues({ ...form.values, duplicateDescription })
          }
          value={form.values.duplicateDescription}
          error={form.errors.duplicateDescription}
          mandatory
        />
      </Box>
    </Modal>
  )
}

export default DuplicateRequestTypeModal
